<template>
  <div style="display: flex; justify-content: center; align-items: center;">
    <div style="position: absolute; bottom: 0;">
      <ExpedientePopUpActionClub ref="MovimientoDetailAction" cardTitle="Detalle" :cardDetail="this.item.description"
        type="detail" :movimiento="this.item"></ExpedientePopUpActionClub>
    </div>
    <v-btn icon flat small @click="goExpediente">
      <v-tooltip bottom>
        <v-icon slot="activator" color="primary">keyboard_arrow_right</v-icon>
        <span>Ver movimiento</span>
      </v-tooltip>
    </v-btn>
  </div>
</template>

<script>
import ExpedientePopUpActionClub from './ExpedientePopUpActionClub.vue'
export default {
  props: {
    item: Object
  },
  components: {
    ExpedientePopUpActionClub
  },
  methods: {
    goExpediente () {
      this.$refs.MovimientoDetailAction.showDialog()
    }
  },
  created () {
  }
}
</script>
